import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Collapsible from 'react-collapsible';
import { propShape } from '../../../../../helpers/custom-prop-types';
import { useBoolState } from '../../../../../helpers/use/useHook';
import Hover from '../../../../Ui/System/Hover';
const ProffitSearchLandingPageSecurity = (props) => {
    const { item } = props;
    const { boolState: isOpen, changeToggle: toggle } = useBoolState();
    return (_jsxs("dl", Object.assign({ className: 'proffit_search_landing_page_security' }, { children: [_jsx("dt", { children: _jsx(Hover, { children: _jsxs("button", Object.assign({ className: 'security_button', onClick: toggle, type: 'button' }, { children: [_jsx("span", Object.assign({ className: 'button_text' }, { children: item.title })), isOpen ? (_jsx(RemoveIcon, { className: 'button_icon' })) : (_jsx(AddIcon, { className: 'button_icon' }))] })) }) }), _jsx(Collapsible, Object.assign({ contentContainerTagName: 'dd', open: isOpen, transitionTime: 250, trigger: '' }, { children: _jsx("p", Object.assign({ className: 'security_description' }, { children: item.description })) }))] })));
};
ProffitSearchLandingPageSecurity.propTypes = {
    item: propShape().isRequired,
};
export default ProffitSearchLandingPageSecurity;
